import { z } from "zod";

export const CreativeElementCategory = z.enum(["HUMAN", "OTHER"]);

export const CreativeElementDto = z.object({
  externalId: z.string(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
  category: CreativeElementCategory,
  teamExternalId: z.string().nullable(),
  thumbnailSrc: z.string(),
  tags: z.array(z.string()),
  width: z.number(),
  height: z.number(),
});

export const CreateCreativeElementDto = z.object({
  tags: z
    .string()
    .optional()
    .refine(
      (val) => {
        if (val === undefined) return true;
        try {
          const parsed = JSON.parse(val);
          return (
            Array.isArray(parsed) &&
            parsed.every((item) => typeof item === "string")
          );
        } catch {
          return false;
        }
      },
      { message: "tags must be a JSON string array" },
    ),
});

export const DeleteCreativeElementResponseDto = z.object({
  success: z.boolean(),
});

export const PagedCreativeElementsRequestDto = z.object({
  elementExternalIds: z.array(z.string()).optional(),
  tags: z.array(z.string()).optional(),
  category: CreativeElementCategory.optional(),
  pageSize: z.number().nullable(),
  cursorCreatedAt: z.string().optional(),
  cursorExternalId: z.string().optional(),
});

export const PagedCreativeElementsResponseDto = z.object({
  elements: z.array(CreativeElementDto),
  nextCursor: z
    .object({
      createdAt: z.string(),
      externalId: z.string(),
    })
    .nullable(),
});

export type CreativeElementCategory = z.infer<typeof CreativeElementCategory>;
export type CreativeElementDto = z.infer<typeof CreativeElementDto>;
export type CreateCreativeElementDto = z.infer<typeof CreateCreativeElementDto>;
export type DeleteCreativeElementResponseDto = z.infer<
  typeof DeleteCreativeElementResponseDto
>;
export type PagedCreativeElementsRequestDto = z.infer<
  typeof PagedCreativeElementsRequestDto
>;
export type PagedCreativeElementsResponseDto = z.infer<
  typeof PagedCreativeElementsResponseDto
>;
